function Navbar() {
  return (
    <nav>
      <div className='logo'>
        <div></div>
      </div>
      <div className='menu-nav'>
        <ul className='menu-links'>
          <li className='menu-items'>Lorem</li>
          <li className='menu-items'>ipsum</li>
          <li className='menu-items'>dolor</li>
          <li className='menu-items'>sit amet</li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
